module.exports = __webpack_public_path__ + "static/img/05-中国农业大学附属中学.8979694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/05-中国农业大学附属中学.png
// module id = AWcC
// module chunks = 0